<template>
  <p class="lxm-avatar image" :style="{ width: `${size}`, height: `${size}` }">
    <template v-if="src">
      <img :src="src">
    </template>
    <template v-else-if="name">
      <div>
        {{ name.trim().substr(0, 1) }}
      </div>
    </template>
    <template v-else-if="isFemale">
      <img src="../../images/main/contact/default-female.png">
    </template>
    <template v-else="isFemale">
      <img src="../../images/main/contact/default-male.png">
    </template>
  </p>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-avatar
    &.image
      img, div
        border-radius: 50%
      div
        display: flex
        justify-content: center
        align-items: center
        width: 100%
        height: 100%
        color: grey-darker
        font-size: siz(18)
        background-color: #eaeaea
</style>

<script>
  export default {
    props: {
      size: {
        type: String,
        default: '100%'
      },
      src: String,
      name: String,
      isFemale: {
        type: Boolean,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmAvatar.vue?7f4b3dd3